import { render, staticRenderFns } from "./detailsQuestion.vue?vue&type=template&id=4d11bd28&scoped=true"
import script from "./detailsQuestion.vue?vue&type=script&lang=js"
export * from "./detailsQuestion.vue?vue&type=script&lang=js"
import style0 from "./detailsQuestion.vue?vue&type=style&index=0&id=4d11bd28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d11bd28",
  null
  
)

export default component.exports